/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React, {useMemo} from 'react'
import parse from 'html-react-parser'
import PropTypes from 'prop-types'
import {Text, Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {findLowestPrice} from '@salesforce/retail-react-app/app/utils/product-utils'
import useSegment from '../../integrations/segment/app/hooks/use-segment'

const PromoCallout = ({product, color}) => {
    const {promotion, data} = useMemo(
        () => findLowestPrice(product) || {promotion: null, data: {}},
        [product]
    )
    const segment = useSegment()

    // NOTE: API inconsistency - with getProduct call, a variant does not have productPromotions
    const promos = data?.productPromotions ?? product?.productPromotions ?? []
    const promo = promotion ?? promos[0]

    // calloutMsg can be html string or just plain text
    return (
        <Box
            data-testid="promo-callout"
            color={color ? color : 'pomegranateBase'}
            fontSize={'12px'}
            fontWeight={'800'}
            lineHeight={'16px'}
            cursor="pointer"
            onClick={() => {
                segment.sendPromoClicked(promos[0])
            }}
        >
            {promo?.calloutMsg && <Text>{parse(promo?.calloutMsg)}</Text>}
        </Box>
    )
}

PromoCallout.propTypes = {
    product: PropTypes.object,
    color: PropTypes.string
}

export default PromoCallout
